export default {
  title: 'HubRise',
  setup: {
    description: 'Condividi dati con altre applicazioni.',
  },
  form: {
    is_menus_sync_enabled: 'Sincronizza menu',
    is_inventory_sync_enabled: 'Sincronizza inventario',
    is_opening_hours_sync_enabled: 'Sincronizza orari di apertura',
    is_order_acceptance_mode_sync_enabled: 'Sincronizza stato occupato / in pausa',
    variant_ref: 'Variante menu',
    variant_ref_default: 'Predefinito',
  },
  tabs: {
    settings: 'Impostazioni',
    service_types: 'Tipi di servizio',
    payments: 'Pagamenti',
    charges: 'Addebiti',
    deals: 'Offerte',
    discounts: 'Sconti',
    customers: 'Clienti',
  },
  customers: {
    description:
      'Cancella i dati di un singolo cliente su HubRise, ad esempio dopo una richiesta di eliminazione. Questa operazione non può essere annullata.',
    customer: 'Cliente',
    placeholder: 'Cerca per nome, email o telefono…',
  },
  mapping: {
    description:
      'Associa ogni entità {{provider}} al valore e nome HubRise corrispondente. Lascia una riga vuota per usare i valori predefiniti di {{provider}}.',
    entity: '{{provider}}',
    value: 'Valore HubRise',
    name: 'Nome HubRise',
  },
  connecting: {
    title: 'Completamento della connessione HubRise…',
    description: 'Ci vogliono alcuni secondi. Tieni aperta questa pagina.',
    error_title: 'La connessione HubRise richiede più tempo del previsto',
    error_description:
      'HubRise è stato autorizzato, ma la connessione non è ancora confermata. Ricontrolla tra un momento — se continua a non riuscire, avvia nuovamente la connessione.',
  },
  buttons: {
    connect: 'Connetti a HubRise',
    check_again: 'Ricontrolla',
    disconnect: 'Disconnetti',
    go_to_hubrise: 'Vai a HubRise',
    pull_menus: 'Importa menu',
    pull_inventory: 'Importa inventario',
    save: 'Salva',
    delete_customer: 'Elimina cliente',
  },
  toasts: {
    connected: 'HubRise è stato connesso',
    connect_cancelled: 'Connessione HubRise annullata',
    connect_error: 'Avvio della connessione HubRise non riuscito',
    connect_timeout: 'La connessione HubRise non è ancora stata confermata',
    local_changes_replaced:
      'Le impostazioni HubRise sono state aggiornate altrove — le modifiche non salvate sono state sostituite',
    disconnect_success: 'HubRise è stato disconnesso',
    disconnect_error: 'Disconnessione di HubRise non riuscita',
    pull_menus_success: 'Sincronizzazione del menu avviata',
    pull_menus_error: 'Importazione del menu non riuscita',
    pull_inventory_success: "Sincronizzazione dell'inventario avviata",
    pull_inventory_error: "Importazione dell'inventario non riuscita",
    save_success: 'Impostazioni HubRise salvate',
    save_error: 'Salvataggio delle impostazioni HubRise non riuscito',
    load_customers_error: 'Caricamento dei clienti non riuscito',
    delete_customer_success: "L'eliminazione dei dati del cliente è stata richiesta",
    delete_customer_error: 'Eliminazione dei dati del cliente non riuscita',
  },
  delete_customer_confirm: {
    title: 'Eliminare questo cliente da HubRise?',
    description: 'I dati del cliente verranno cancellati su HubRise. Questa operazione non può essere annullata.',
    ok: 'Elimina',
    cancel: 'Annulla',
  },
  disconnect_confirm: {
    title: 'Disconnettere HubRise?',
    description: 'La sincronizzazione di menu, inventario e ordini con HubRise verrà interrotta.',
    ok: 'Disconnetti',
    cancel: 'Annulla',
  },
  connected: {
    title: 'Connesso a HubRise',
    description: 'Il tuo account HubRise è collegato con successo.',
    account: 'Account',
    location: 'Sede',
    catalog: 'Catalogo',
    customer_list: 'Lista clienti',
  },
};
